import React, { useState } from 'react';
import { IonContent, IonPage, IonCard, IonCardContent, IonList, IonItem, IonLabel, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonText, IonDatetime, IonIcon } from '@ionic/react';
import { useQuery } from '@tanstack/react-query';
import { GetAppointmentsByDate } from '../data/api';
import { Link, RouteComponentProps} from 'react-router-dom';
import '../shared/SchedulingShared.css';
import { arrowDownCircle, locationOutline, timeOutline, informationCircleOutline } from 'ionicons/icons';

interface StateProps {
  title: string
}


interface RouteProps extends RouteComponentProps<{ dateValue: string }> { }
interface GenericProps extends RouteProps, StateProps { }

const Passport: React.FC<GenericProps> = ({ match, title }) => {


 //---Set Intial Value of the Date--------------------------------

  if (match.params.dateValue == null) {
    match.params.dateValue = new Date().toISOString();
  }

  let today = new Date(new Date(match.params.dateValue).toDateString());

  const [selectedDate, setSelectedDate] = useState<string>(today.toISOString());

  //---GetDatetList--------------------------------
  function GetDatetList(props: any) {
    const myQuery = useQuery({ queryKey: ["GetAppointmentsByDate", props.myType, props.myDate], queryFn: () => GetAppointmentsByDate(props.myType, props.myDate) });
    return (
      <div>
        {myQuery.isLoading && (
          <IonItem>
            Loading
          </IonItem>
        )}
        {myQuery.isSuccess && myQuery.data.length === 0 && (
          <IonItem lines="none">
            <IonLabel color="medium">No time slots for this date.</IonLabel>
          </IonItem>
        )}
        {
          myQuery.isSuccess && myQuery.data.map((dateString: any) =>
          (

            <IonItem key={dateString.aptkey}>
              <div
                className="scheduling-slot-indicator"
                data-aptsts={dateString.aptsts}
                slot="start"
              >
                &nbsp;
              </div>
              <div>
                {dateString.aptsts === 'A' ? (
                  <div>
                    <Link 
                      to={{
                        pathname: "/tabs/passportapt/" + encodeURIComponent(dateString.aptkey.toString())
                      }}>
                      <IonLabel>
                      {dateString.aptst}
                        -
                      {dateString.apted}
                        </IonLabel>
                    </Link>
                  </div>
                ) :
                  (
                    <div className="scheduling-slot-label-muted">
                      <IonLabel>
                      {dateString.aptst}
                        - 
                      {dateString.apted}
                      </IonLabel>
                    </div>
                  )
                }
              </div>
             
              <div slot="end" className="scheduling-slot-name-muted">
                <IonLabel>
                  {dateString.aptname}
                  </IonLabel>
              </div>

            </IonItem>))
        }
      </div>
      );
  }

return (
  <IonPage>
    
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton />
        </IonButtons>
        <IonTitle color="primary">Passport Services</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent color="light" className="passport-page">
      <div className="passport-layout">
            <IonCard className="passport-info-panel">
              <IonCardContent className="passport-info-card">
                <div className="passport-info-columns">
                  <section className="passport-info-pane">
                    <h2 className="passport-info-pane-title">
                      <IonIcon icon={locationOutline} aria-hidden="true" />
                      Location
                    </h2>
                    <IonText>
                      <p className="passport-info-line"><strong>311 Help Desk (Room 110)</strong></p>
                      <p className="passport-info-line">56 North State Street<br />Orem, UT 84057</p>
                    </IonText>
                  </section>

                  <div className="passport-info-divider" aria-hidden="true" />

                  <section className="passport-info-pane">
                    <h2 className="passport-info-pane-title">
                      <IonIcon icon={timeOutline} aria-hidden="true" />
                      Hours of operation
                    </h2>
                    <IonText className="passport-info-hours">
                      <p><span className="passport-hours-days">Monday, Tuesday, Thursday:</span> 7:30 AM to 5:00 PM</p>
                      <p><span className="passport-hours-days">Wednesday:</span> 8:30 AM to 5:00 PM</p>
                      <p><span className="passport-hours-days">Friday:</span> 8:00 AM to 4:00 PM</p>
                      <p className="passport-hours-breaks">
                        <span className="passport-hours-days">Daily breaks (Monday–Friday):</span> 11:30 AM to 12:00 PM and 12:30 PM to 1:00 PM (no appointments)
                      </p>
                      <p><span className="passport-hours-days">Saturday &amp; Sunday:</span> <span className="passport-hours-closed">Closed</span></p>
                    </IonText>
                  </section>
                </div>

                <div className="passport-info-note" role="note">
                  <IonIcon icon={informationCircleOutline} aria-hidden="true" />
                  <span>
                    To schedule an appointment, click a <strong className="passport-info-note-slot"><span className="passport-info-note-green">green</span> open slot</strong> below.
                  </span>
                </div>
              </IonCardContent>
            </IonCard>

            <div className="passport-schedule-row">
            <IonCard>
                <IonCardContent>
                  <IonItem lines="none">
                    <IonIcon slot="start" icon={arrowDownCircle} color="primary"></IonIcon>
                    <IonLabel>
                    Selected Date  
                    </IonLabel>
                  </IonItem>
                <IonItem mode="ios" lines="none" >
                  <IonDatetime
                    value={selectedDate}
                    presentation="date"
                    onIonChange={(e: any) => { setSelectedDate(e.detail.value!) }}
                    placeholder="Select Time"
                  >
                  </IonDatetime>

                  </IonItem>
                </IonCardContent>
              </IonCard>
            <IonCard>
                <IonCardContent>
                  <IonList>
                    <GetDatetList myType='P' myDate={selectedDate} />
                  </IonList>
                </IonCardContent>
              </IonCard>
            </div>
      </div>
    </IonContent>
  </IonPage>
);
}

export default Passport;
